export interface TreeNode {
	type: 'DIRECTORY' | 'FILE';
	path: string;
	children: TreeNodeChildren;
}

export interface TreeNodeChildren {
	[path: string]: TreeNode;
}

function getBaseNode(): TreeNode {
	return {
		type: 'DIRECTORY',
		path: '',
		children: {},
	};
}

function joinPaths(base: string, path: string) {
	return base ? `${base}/${path}` : path;
}

function addToTree(node: TreeNode, path: string) {
	const parts = path.split('/');
	let currentNode = node;
	parts.forEach(part => {
		if (!currentNode.children[part]) {
			currentNode.children[part] = {
				type: 'DIRECTORY',
				path: joinPaths(currentNode.path, part),
				children: {},
			};
		}
		currentNode = currentNode.children[part];
	});
	currentNode.type = 'FILE';
}

export function getFileTree(paths: string[]) {
	const node = getBaseNode();
	paths.forEach(path => {
		addToTree(node, path);
	});
	return node;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/config-editor/treeview/pathUtils.ts